import React from "react";

const MenuChucNang = ({RoleNhapQuy,RoleRutQuy, btnNhapQuyClick,btnRutQuyClick }) => (
    <div className="search-new" >
        <div className="input-sm-new" style={{minWidth:"12%",display: RoleNhapQuy ? "block" : "none",}}>
            <button className="btn btn-w-m mb-1 btn-sm" onClick={btnNhapQuyClick} style={{maxWidth:"100%",minWidth:"100%",color: "#00B69B", border: "2px solid #00B69B", backgroundColor: "white" }}><i class="fas fa-funnel-dollar"></i> Nhập quỹ</button>
        </div>
        <div className="input-sm-new" style={{minWidth:"12%",display: RoleRutQuy ? "block" : "none",}}>  
            <button className="btn btn-w-m mb-1 btn-sm" onClick={btnRutQuyClick} style={{maxWidth:"100%",minWidth:"100%",color: "#cc2931ff", border: "2px solid #cc2931ff", backgroundColor: "white" }}><i class="fas fa-wallet"></i> Rút quỹ</button>
        </div>
    </div>
);

export default MenuChucNang;